import { t } from "@lingui/core/macro";
import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Title from "../title";
import Footer from "../footer";
import WebEditorRender from "../../../components/WebEditor";
import PageTitle from "../theme/components/pagetitle";
import {ASSET_URL} from "../../../config";
import {applyLang} from "../../../i18n";
import Loader from "../loader";
import {Trans} from "@lingui/react/macro";
import logger from "../../../services/logger"

export default class Page404 extends Component{

    render(){
        const context=this.props.context
        const {org,config,data}=context

        logger.debug({ data }, "data")

        const title="404"

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={title} description={null} image={null}/>
                    <Loader/>
                </div>
            )
        }

        return (
            <div>
                <Meta context={context} title={t`Page introuvable`} description={null} image={null}/>
                <Header context={context}/>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 500,
                        textAlign: "center",
                        gap: 16
                    }}
                >
                    <h1 style={{margin: 0}}>404</h1>
                    <h2 style={{margin: 0, fontWeight: 500}}>
                        <Trans>Cette page est introuvable.</Trans>
                    </h2>
                    <p style={{maxWidth: 400, margin: 0, opacity: 0.7}}>
                        <Trans>
                        Le lien est peut-être incorrect ou la page a été supprimée.
                        Vous pouvez revenir à l’accueil ou utiliser la navigation pour continuer.
                        </Trans>
                    </p>

                    <a
                        href={org.BASE_WEB_URL}
                        style={{
                            marginTop: 16,
                            padding: "10px 20px",
                            borderRadius: 6,
                            textDecoration: "none",
                            backgroundColor: "#111",
                            color: "#fff",
                            fontWeight: 500
                        }}
                    >
                        <Trans>Retour à l’accueil</Trans>
                    </a>
                </div>

                <Footer context={context}/>
            </div>

        )
    }
}
